import { z } from "zod"

export const SalesForceQueryTotal = z.object({
  totalSize: z.number(),
  done: z.boolean(),
  records: z.array(
    z.object({
      attributes: z.object({
        type: z.string(),
      }),
      total: z.number(),
    }),
  ),
})

export const SalesForceQueryGeneric = z.object({
  totalSize: z.number(),
  done: z.boolean(),
  records: z.array(
    z.record(
      z.string(),
      z.union([z.string(), z.number(), z.boolean(), z.record(z.string(), z.unknown())]).nullable(),
    ),
  ),
})

export const GetSalesForceIntegrationSchema = z.object({
  id: z.string().transform(BigInt),
})

export const UpsertSalesForceIntegrationBodySchema = z.object({
  baseUrl: z.string(),
  clientId: z.string(),
  clientSecret: z.string(),
  redirectUrl: z.string(),
  refreshToken: z.string(),
})

export const SalesForceIntegrationModels = z.enum(["CONTACT"])
export const UpdateSalesForceKeyMapParams = z.object({
  model: SalesForceIntegrationModels,
})
export const UpdateSalesForceKeyMapBody = z.object({
  keyMap: z.array(z.object({ key: z.string(), source: z.string() })),
})
